import { Avatar } from '@lifeomic/chroma-react/components/Avatar';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { Subject } from '@lifeomic/phc-web-toolkit/src/common/types/Subject';
import * as React from 'react';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {},
}));

interface SubjectAvatarProps {
  className?: string;
  isMaskedModeEnabled?: boolean;
  subject?: Subject;
}

export const SubjectAvatar: React.FC<SubjectAvatarProps> = ({
  className,
  isMaskedModeEnabled,
  subject,
}) => {
  const classes = useStyles({});

  if (!subject?.patientHasPhoto) {
    return null;
  }

  const subjectPhoto = subject?.photo?.[0];
  const subjectPhotoSource =
    !isMaskedModeEnabled && subjectPhoto
      ? `data:${subjectPhoto.contentType};base64,${subjectPhoto.data}`
      : null;

  return (
    <Avatar
      size={2}
      className={clsx(classes.root, className)}
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      src={subjectPhotoSource}
      useDefaultSrc={!!isMaskedModeEnabled}
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      name={subject?.name?.display}
    />
  );
};
